class FilterHelper {
  definedFilters() {
    return [
      {title: 'Total capacity', fieldName: 'field_capacity', type: 'slider', filterType: 'range'},
      {title: 'Venue type', fieldName: 'field_venue_type', type: 'checkboxes', filterType: 'term'},
      {title: 'Location', fieldName: 'field_area', type: 'checkboxes', filterType: 'term'},
      {title: 'Layout of the room', fieldName: 'field_layout', type: 'checkboxes', filterType: 'term'},
      {title: 'Sustainable', fieldName: 'field_sustainable', type: 'checkboxes', filterType: 'boolean'},
      {title: 'Search', fieldName: 'field_search', type: 'text', filterType: 'search'},
    ];
  }

  getInitialFormValues() {
    let initialValues = {};
    let definedFilters = this.definedFilters();
    for (let filterIndex in definedFilters) {
      if (definedFilters[filterIndex].type === 'slider'){
        initialValues[definedFilters[filterIndex].fieldName] = {};
        initialValues[definedFilters[filterIndex].fieldName].min = 0;
        initialValues[definedFilters[filterIndex].fieldName].max = 999; // Weird number to spot errors
      } else {
        initialValues[definedFilters[filterIndex].fieldName] = [];
      }
    }
    return initialValues;
  }

  isFilterType(fieldName, filterType) {
    let definedFilters = this.definedFilters();
    let definedFilter = definedFilters.find(obj => {return obj.fieldName === fieldName});
    return (definedFilter.filterType === filterType)
  }

}

export default FilterHelper;
